<template>
  <b-card
    :img-src="require(`@/assets/images/promos/${img}.png`)"
    img-alt="Promo App"
    img-top
    tag="article"
    class="mb-4"
  >
    <b-card-title class="title">
      {{ $t('dashboard.promos.app.title') }}
    </b-card-title>
    <b-card-text>
      {{ $t('dashboard.promos.app.subtitle') }}
      <a
        :href="item.link"
        target="_blank"
        class="d-flex justify-content-between align-items-center my-3 text-secondary"
        v-for="item in $t('dashboard.promos.app.links')"
        :key="item.id"
      >
        <div>
          <b-img
            :src="require(`@/assets/images/promos/${item.icon}`)"
            width="20"
          />
          <span class="ml-2">{{ item.title }}</span>
        </div>
        <span><b-icon-box-arrow-up-right font-scale="0.9" /></span>
      </a>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  computed: {
    img() {
      return this.$store.state.account.country === 'Mexico' ? 'm-mx' : 'm-in'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
.title {
  font-family: $montserrat;
  font-weight: 600;
}
</style>
